import router from '@/router';

import Page from './module/page.vue'
import Topbar from './module/topbar.vue'
import ViewList from './module/view_list.vue'
import ViewListCard from './module/view_list_card.vue'
import ViewDocCard from './module/view_doc_card.vue'

import DetailBase from './module/detail_base.vue'
import DetailContent from './module/detail_content.vue'
import DetailHandle from './module/detail_handle.vue'

import DocFlow from './module/doc_flow.vue'
import DocBase from './module/doc_base.vue'
import DocContent from './module/doc_content.vue'
import DocLog from './module/doc_log.vue'
import DocHandle from './module/doc_handle.vue'

import DetailCard from './module/detail_card.vue'
import DetailCardForm from './module/detail_card_form.vue'
import DetailCardList from './module/detail_card_list.vue'
import DetailCardListRow from './module/detail_card_list_row.vue'

import goodsCard from './module/goods_card.vue'
import logItem from './module/log_item.vue'

import memberList from './module/member_list.vue'
import memberItem from './module/member_item.vue'
import memberIcon from './module/member_icon.vue'

import CustomForm from './module/custom_form.vue'
import CustomDetail from './module/custom_detail.vue'

import Search from './module/search.vue'
import SearchItem from './module/search_item.vue'

import Field from './public/field.vue'
import State from './public/state.vue'
import Tags from './public/tags.vue'
import FileList from './public/file_list.vue'
import ScanCode from './public/scan_code.vue'
import ProcessRate from './public/process_rate.vue'
import DetailBar from './public/detail_bar.vue'
import HandleBar from './public/handle_bar.vue'
import SelectOption from './public/select_option.vue'
import ReasonOption from './public/reason_option.vue'
import timePicker from './public/time_picker.vue'
import InfoCard from './public/info_card.vue'
import CutLine from './public/cut_line.vue'
import InsertData from './public/insert_data.vue'
import Tips from './public/tips.vue'
import File from './public/file.vue'
import Location from './public/location.vue'

import cDatetimePicker from './extand/datetime_picker.vue'

const COMPS = [
	Page,
	Topbar,
	ViewList,
	ViewListCard,
	ViewDocCard,

	DetailBase,
	DetailContent,
	DetailHandle,

	DocFlow,
	DocBase,
	DocContent,
	DocLog,
	DocHandle,

	DetailCard,
	DetailCardForm,
	DetailCardList,
	DetailCardListRow,

	goodsCard,
	logItem,

	memberList,
	memberItem,
	memberIcon,

	CustomForm,
	CustomDetail,

	Search,
	SearchItem,

	Field,
	State,
	Tags,
	FileList,
	ScanCode,
	ProcessRate,
	DetailBar,
	HandleBar,
	SelectOption,
	ReasonOption,
	timePicker,
	InfoCard,
	CutLine,
	InsertData,
	Tips,
	File,
	Location,

	cDatetimePicker
]

const DYNAMIC_COMPS = [
];

// 导出组件
export default {
	install: function(Vue) {
		COMPS.forEach(comp => {
			Vue.component(comp.name, comp);
		})

		DYNAMIC_COMPS.forEach(comp => {
			let constructor = Vue.extend(comp);
			Vue.prototype[`$${comp.name}`] = function(opt = {}) {
				opt.dom = opt.dom || document.body
				let vm = new constructor({
					router,
					el: document.createElement('div'),
					data() {
						return opt
					}
				});

				if (opt.events) {
					for (let event in opt.events) {
						vm.$on(event, opt.events[event]);
					}
				}

				opt.dom.appendChild(vm.$el);
				return vm;
			}
		});
	}
}